import { render, staticRenderFns } from "./PartnerReportDetailInfoCard.vue?vue&type=template&id=503209b7&scoped=true&"
import script from "./PartnerReportDetailInfoCard.vue?vue&type=script&lang=ts&"
export * from "./PartnerReportDetailInfoCard.vue?vue&type=script&lang=ts&"
import style0 from "./PartnerReportDetailInfoCard.vue?vue&type=style&index=0&id=503209b7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "503209b7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCard,VCardTitle,VCol,VDivider,VRow,VSimpleTable})
